module.exports = __webpack_public_path__ + "assets/img/safari-pinned-tab.svg";